import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Download from '@mui/icons-material/GetApp';
import DeleteIcon from '@mui/icons-material/Delete';
import OpenIcon from '@mui/icons-material/OpenInBrowser';
import DetailsIcon from '@mui/icons-material/List';
import LaunchIcon from '@mui/icons-material/Launch';
import AddIcon from '@mui/icons-material/Add';
import CloudUpload from '@mui/icons-material/CloudUpload';
import styled from 'src/ui/library/styled';
import EditIcon from '@mui/icons-material/EditNote';

const ITEM_HEIGHT = 48;

const styles = theme => ({
  vertIcon: {
    transform: 'rotate(90deg)',
    fontSize: '3rem',
    fill: '#C4C4CD',
  },
  icon: {
    marginRight: '1rem',
  },
  menuItem: {
    color: theme.colors.eyConfidentGrey,
    fontSize: '0.875rem',
    minHeight: ITEM_HEIGHT,
    '&:hover, &:focus, &.Mui-focusVisible': {
      backgroundColor: `${theme.colors.eyGrey4} !important`,
    },
    '&.Mui-disabled': {
      opacity: 0.5,
    },
  },
});

class ThreeDotMenuBase extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    handleMenuSelect: PropTypes.func,
    options: PropTypes.array,
    rootClassName: PropTypes.string,
    tableData: PropTypes.any,
    tableMeta: PropTypes.any,
    tableValue: PropTypes.any,
  };

  static defaultProps = {
    handleMenuSelect: () => {},
    options: [],
    rootClassName: '',
  };

  state = {
    anchorEl: null,
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = type => {
    const { handleMenuSelect, tableMeta } = this.props;
    this.setState({ anchorEl: null }, () => {
      if (typeof type === 'string') {
        handleMenuSelect(type, tableMeta);
      }
    });
  };

  /** should refactor this to receive an child icon element prop from the caller not to be imported directly to here */
  renderIcon = (type, iconClass) => {
    let icon = null;
    if (type === 'package' || type === 'status') icon = <Download className={iconClass} />;
    else if (type === 'delete') icon = <DeleteIcon className={iconClass} />;
    else if (type === 'open') icon = <OpenIcon className={iconClass} />;
    else if (type === 'details') icon = <DetailsIcon className={iconClass} />;
    else if (type === 'view') icon = <LaunchIcon className={iconClass} />;
    else if (type === 'add') icon = <AddIcon className={iconClass} />;
    else if (type === 'upload') icon = <CloudUpload className={iconClass} />;
    else if (type === 'edit') icon = <EditIcon className={iconClass} />;
    return icon;
  };

  render() {
    const { classes, options, rootClassName, ...otherProps } = this.props;
    const { anchorEl } = this.state;
    const menuOptions = Array.isArray(options) ? options : [];
    delete otherProps.handleMenuSelect;
    delete otherProps.tableMeta;
    delete otherProps.tableData;
    delete otherProps.tableValue;

    return (
      <div
        className={rootClassName || ''}
        onClick={e => {
          e.stopPropagation();
        }}>
        <IconButton aria-label="More" aria-owns={anchorEl ? 'long-menu' : null} aria-haspopup="true" onClick={e => this.handleClick(e)}>
          <MoreVertIcon className={classes.vertIcon} />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4,
              width: 'auto',
            },
          }}
          {...otherProps}>
          {menuOptions.map((option, index) =>
            option ? (
              <MenuItem
                className={classes.menuItem}
                key={option + '-' + index * Math.random()}
                disabled={option.disabled ? option.disabled : false}
                selected={false}
                onClick={this.handleClose.bind(this, option.type)}>
                {this.renderIcon(option.type, classes.icon)}
                {option.title}
              </MenuItem>
            ) : null,
          )}
        </Menu>
      </div>
    );
  }
}

export default styled(ThreeDotMenuBase)(styles);
